import { watchEffect } from "vue";

import { onSetCookie } from "@solvari/utils";

import type { ConsentTypes } from "@/organisms/cookie-popup/useCookiePopup.ts";

import { useCookiePopup } from "@/organisms/cookie-popup/useCookiePopup.ts";

import "./sCookiePopup.css";

function initCookiePopup() {
  const {
    visible,
    step,
    analyticsStorage,
    adStorage,
    acceptClick,
    submitCustom,
  } = useCookiePopup();

  const cookiePopupEl = document.querySelector<HTMLElement>(
    "[data-cookie-popup=container]",
  );
  if (!cookiePopupEl) {
    return;
  }

  const step1Element = cookiePopupEl.querySelector<HTMLDivElement>(
    "[data-cookie-popup='step-1']",
  )!;
  const step2Element = cookiePopupEl.querySelector<HTMLFormElement>(
    "[data-cookie-popup='step-2']",
  )!;
  const acceptButtonEls = cookiePopupEl.querySelectorAll(
    "[data-cookie-popup=btn-accept]",
  );
  const step2ButtonEl = cookiePopupEl.querySelector(
    "[data-cookie-popup=btn-step-2]",
  )!;
  const analyticsOptionEl = cookiePopupEl.querySelector<HTMLInputElement>(
    "input[value=analytics_storage]",
  )!;
  const adStorageEl = cookiePopupEl.querySelector<HTMLInputElement>(
    "input[value=ad_storage]",
  )!;

  watchEffect(() => {
    cookiePopupEl.style.display = visible.value ? "grid" : "none";
  });
  watchEffect(() => {
    step1Element.style.display = step.value === 1 ? "block" : "none";
  });
  watchEffect(() => {
    step2Element.style.display = step.value === 2 ? "block" : "none";
  });

  acceptButtonEls.forEach((button) =>
    button.addEventListener("click", acceptClick),
  );

  step2ButtonEl.addEventListener("click", () => (step.value = 2));

  step2Element.addEventListener("submit", (event) => {
    event.preventDefault();
    submitCustom();
  });

  function toggleOptionEl(optionEl: HTMLInputElement, value: boolean) {
    optionEl.checked = value;
    optionEl
      .closest<HTMLLabelElement>(".cookie-popup__option")
      ?.classList.toggle("cookie-popup__option--checked", value);
  }

  analyticsOptionEl.addEventListener("change", ({ currentTarget }) => {
    analyticsStorage.value = (currentTarget as HTMLInputElement).checked;
  });
  watchEffect(() => {
    toggleOptionEl(analyticsOptionEl, analyticsStorage.value);
  });
  adStorageEl.addEventListener("change", ({ currentTarget }) => {
    adStorage.value = (currentTarget as HTMLInputElement).checked;
  });
  watchEffect(() => {
    toggleOptionEl(adStorageEl, adStorage.value);
  });

  document
    .querySelectorAll("[data-cookie-popup=btn-open]")
    .forEach((button) =>
      button.addEventListener("click", () => (visible.value = true)),
    );

  function replaceMarketingCookieBlockers(cookieConsentCookie: ConsentTypes) {
    if (!cookieConsentCookie.includes("ad_storage")) {
      return;
    }

    document
      .querySelectorAll<HTMLElement>(
        ".marketing-cookie-blocker[data-type=youtube]",
      )
      .forEach((element) => {
        if (!element.dataset.url) {
          return;
        }
        element.outerHTML = `
        <div class="video-container">
          <iframe allowFullScreen frameBorder="0" src="${element.dataset.url}"></iframe>
        </div>
      `;
      });
  }
  onSetCookie("solvariCookieConsent", replaceMarketingCookieBlockers);
}

export { initCookiePopup };
